import { Transaction, TRANSACTIONS } from './megaMenuConstants/transactions';

export const getTransactions = (keys: string[], category: string) => {
  return keys.map((key, i) => {
    TRANSACTIONS[category][key].id += `-${i}`;
    return TRANSACTIONS[category][key];
  });
};

export const filterTransactionsByDisplayFlag = (transactions: Transaction[]) =>
  transactions.filter(
    (transaction) =>
      !transaction.displayFlag || transaction.displayFlag === 'true',
  );
